import { NgModule } from '@angular/core';
import { SharedModule } from './../../../shared/modules/shared.module';
import { AnnualRenewalComponent } from './annual-renewal.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  imports: [
    SharedModule,
    NgxMaskModule
  ],
  declarations: [
    AnnualRenewalComponent
  ]
})
export class AnnualRenewalModule { }
